const LightThemeColors = [
  {
    name: 'NANG',
    palette: {
      primary: {
        main: '#00857D',
        light: '#d7ecea',
        // dark: '#00716a',
        contrastText: '#ffffff'
      },
      secondary: {
        main: '#330000',
        // light: '#eea75b',
        // dark: '#5a0000',
        contrastText: '#ffffff'
      },
      error: {
        main: '#DF2901',
        // light: '#991C00',
        // dark: '#E9694D',
        contrastText: '#ffffff'
      },
      warning: {
        main: '#FBD300',
        // light: '#DFFC30',
        // dark: '#615100',
        contrastText: '#121212'
      },
      info: {
        main: '#2196f3',
        // light: '#64b5f6',
        // dark: '#1976d2',
        contrastText: '#fff'
      },
      success: {
        main: '#29A855',
        // light: '#2CB55C',
        // dark: '#10602C',
        contrastText: '#ffffff'
      },
      text: {
        primary: '#121212',
        secondary: '#5F5753',
        disabled: 'rgba(36, 36, 36, 0.38)',
        hint: 'rgba(36, 36, 36, 0.38)',
        navSecondary: '#121212',
        navActive: '#121212',
        textSecondary: '#121212',
        textActive: '#121212',
        error: '#C91A13',
        success: '#29A855',
        gray900: '#1C1D21CC',
        tooltip: '#1C1D21',
        cngBlack: '#1C1D21',
        widgetTitle: '#1c1d21',
        widgetSubTitle: '#7680a3',
        base: '#121212'
      }
    },
  }
];

export { LightThemeColors };
